import Vue from 'vue';
import {isString} from './util';
Vue.filter('replaceNewLine', (value: any, replacement: string) => {
  if (value) {
    return value.replace(/\n/g, replacement);
  }
  return value;
});


export function trimString(input: string, searchString: string): string {
  if (!isString(input)) return '';

  let result = input;
  let indexEnd = result.length;
  let indexStart = 0;
  if (input.endsWith(searchString)) indexEnd = indexEnd - searchString.length;
  if (input.startsWith(searchString)) indexStart = searchString.length;
  result = result.substring(indexStart, indexEnd);

  return result;
}


// WEBPACK FOOTER //
// node_modules/wc-lib/src/wc-converters/string.ts